/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `Minimální délka hesla je ${i.length}`
};

const da_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `Adgangskoden skal mindst være ${i.length} tegn`
};

const de_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `Das Passwort muss mindestens ${i.length} Zeichen lang sein`
};

const en_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `The minimum password length is ${i.length}`
};

const es_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `La longitud mínima de la contraseña es ${i.length}`
};

const fr_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `La longueur minimale du mot de passe est ${i.length}`
};

const hu_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `A jelszó minimális hossza: ${i.length}`
};

const it_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `La lunghezza minima della password è ${i.length}`
};

const nl_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `Het wachtwoord moet minimaal ${i.length} tekens bevatten`
};

const pl_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `Minimalna długość hasła to ${i.length}`
};

const pt_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `O comprimento mínimo da senha é ${i.length}`
};

const sv_account_password_requirements = /** @type {(inputs: { length: NonNullable<unknown> }) => string} */ (i) => {
	return `Minsta lösenordslängd är ${i.length}`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ length: NonNullable<unknown> }} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_password_requirements = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_password_requirements(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_password_requirements", locale)
	if (locale === "cs") return cs_account_password_requirements(inputs)
	if (locale === "da") return da_account_password_requirements(inputs)
	if (locale === "de") return de_account_password_requirements(inputs)
	if (locale === "en") return en_account_password_requirements(inputs)
	if (locale === "es") return es_account_password_requirements(inputs)
	if (locale === "fr") return fr_account_password_requirements(inputs)
	if (locale === "hu") return hu_account_password_requirements(inputs)
	if (locale === "it") return it_account_password_requirements(inputs)
	if (locale === "nl") return nl_account_password_requirements(inputs)
	if (locale === "pl") return pl_account_password_requirements(inputs)
	if (locale === "pt") return pt_account_password_requirements(inputs)
	return sv_account_password_requirements(inputs)
};
export { account_password_requirements as "account.password_requirements" }